import React from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import { DayPickerSingleDateController } from 'react-dates';
import theme from './ReactDatePicker.scss';
import Icon from 'common/components/core/icon';
import moment from 'moment-timezone';

const datePickerFactory = ({
    DatePickerComponent = DayPickerSingleDateController
}) => {
    class DatePicker extends React.PureComponent {
        renderCalendarInfo = () => {
            const days = moment.weekdaysMin();
            return (
                <ul className={theme.customHeader}>
                    {days.map((day, index) => {
                        return <li key={index}>{day}</li>;
                    })}
                </ul>
            );
        };
        render() {
            const {
                date,
                startDate,
                endDate,
                onDateChange,
                onDatesChange,
                onFocusChange,
                focusedInput,
                focused,
                minimumNights,
                initialVisibleMonth,
                className,
                isDayHighlighted,
                isDayBlocked,
                isStartSelected,
                isEndSelected,
                isMultiDay
            } = this.props;
            const nextIcon = (
                <Icon
                    theme={theme}
                    className={theme.navigationIcon}
                    icon="arrow-right"
                />
            );
            const prevIcon = (
                <Icon
                    theme={theme}
                    className={theme.navigationIcon}
                    icon="arrow-left"
                />
            );
            return (
                <div
                    className={classnames(theme.reactDatePicker, className, {
                        [theme.noEndDate]: !endDate,
                        [theme.isMultiDay]: isMultiDay,
                        [theme.isEndSelected]: isEndSelected,
                        [theme.isStartSelected]: isStartSelected
                    })}
                >
                    <DatePickerComponent
                        daySize={36}
                        numberOfMonths={1}
                        date={date}
                        startDate={startDate}
                        endDate={endDate}
                        onDateChange={onDateChange}
                        onDatesChange={onDatesChange}
                        focusedInput={focusedInput}
                        focused={focused}
                        onFocusChange={onFocusChange}
                        navPrev={prevIcon}
                        navNext={nextIcon}
                        renderCalendarInfo={this.renderCalendarInfo}
                        showKeyboardShortcuts={false}
                        minimumNights={minimumNights}
                        hideKeyboardShortcutsPanel
                        initialVisibleMonth={initialVisibleMonth}
                        isDayHighlighted={isDayHighlighted}
                        isDayBlocked={isDayBlocked}
                        horizontalMonthPadding={0}
                    />
                </div>
            );
        }
    }
    return themr('DatePicker', theme)(DatePicker);
};

const SingleDatePicker = datePickerFactory({});
export default SingleDatePicker;
export { SingleDatePicker, datePickerFactory };
